module.exports = __webpack_public_path__ + "static/media/NotoSans-BoldItalic.c55a2462.ttf";